import { endOfDay } from 'date-fns';
import { createContext } from 'react';

// Context that provides a global maxDate constraint for all CustomDatePicker instances in a subtree.
// Used by DetailForm to enforce dataOptionsMax (e.g. restrict date to today).
export const DatePickerMaxDateContext = createContext<Date | null | undefined>(undefined);

// Returns end of today (23:59:59.999) — used as maxDate when dataOptionsMax is enabled.
export const getEndOfToday = () => endOfDay(new Date());
